import styled from 'styled-components'

export const StyledDeliverQuestionModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${props => props.theme.spacing.medium};
`

export const StyledPackageOrVehicleWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-evenly;
  padding: ${props => props.theme.spacing.medium};

  & > section {
    margin-left: ${props => props.theme.spacing.small};
    margin-right: ${props => props.theme.spacing.small};
  }
`

export const StyledButtonGroup = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: ${props => props.theme.spacing.large};
  margin-bottom: ${props => props.theme.spacing.medium};

  & > button {
    margin: ${props => props.theme.spacing.small};
  }
`
